"use client";

import { publicUrls } from "@/constants";
import IconTextToSpeach from "@ui/central-icons/icons/IconTextToSpeach";
import IconVoice3 from "@ui/central-icons/icons/IconVoice3";
import IconWorld from "@ui/central-icons/icons/IconWorld";
import { iconStrokeFix } from "@ui/central-icons/iconUtils";
import { SignUpPopover } from "@ui/components/core/SignUpPopover";
import { EventName } from "@mw/shared/analyticsEventNames";
import clsx from "clsx";
import { useTranslations } from "next-intl";
import { TTSDownloadPopoverCover } from "./TTSDownloadPopoverCover";

export function TTSDownloadSignUpPopover({
  isOpen,
  onOpenChange,
}: {
  isOpen: boolean;
  onOpenChange: (open: boolean) => void;
}) {
  const t = useTranslations("ClientKeys.SliderGenerateTTSDemoPopover");

  return (
    <SignUpPopover
      isOpen={isOpen}
      onOpenChange={onOpenChange}
      cover={<TTSDownloadPopoverCover />}
      title={t("title")}
      featureItems={[
        {
          icon: <IconTextToSpeach className={clsx(iconStrokeFix, "tw-size-[18px]")} />,
          text: t("feature_download"),
        },
        {
          icon: <IconVoice3 className={clsx(iconStrokeFix, "tw-size-[18px]")} />,
          text: t("feature_audio"),
        },
        {
          icon: <IconWorld className={clsx(iconStrokeFix, "tw-size-[18px]")} />,
          text: t("feature_tools"),
        },
      ]}
      ctaText={t("cta")}
      ctaHref={`${publicUrls.signUp}?redirect=/app/speech-synthesis/text-to-speech`}
      ctaEventName={EventName.mw_tts_signup_popover_cta_clicked}
    />
  );
}
